/**
 * Plate format eDalnice accepts on /api/v3/charge_registrations: no whitespace, no hyphens,
 * uppercase. Their API answers 400 "license_plate is invalid" for anything else, which the
 * storefront can only report as "no vignette found".
 *
 * Hyphens matter because German and Austrian plates are entered with them on purpose
 * (see BuyVignette/components/TextInput.vue, allowHyphen), e.g. "B-AB 1234" → "BAB1234".
 *
 * Keep in sync with {@see \App\Support\LicensePlateForApi}.
 */

/** Hyphen-minus plus the Unicode dashes that reach us from keyboards and copy-paste. */
const DASHES = /[-\u00AD\u2010-\u2015\u2212\uFE58\uFE63\uFF0D]/g;

/** Non-breaking / zero-width characters that survive a plain trim. */
const INVISIBLES = /[\u00A0\u2000-\u200B\uFEFF]/g;

export function licensePlateForApi(raw) {
    return String(raw ?? '')
        .normalize('NFKC')
        .replace(INVISIBLES, '')
        .replace(DASHES, '')
        .replace(/\s+/g, '')
        .toUpperCase();
}
